// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1CgVD","itemTitle":"ClientEmergencyInfo_itemTitle__2n94B","itemText":"ClientEmergencyInfo_itemText__33-oZ"};